import { useEffect, useState } from "react";
import { MdNotes } from "react-icons/md";
import Button from "../../common/button";
import NavWrapper from "./Header.style";
import MobileMenu from "./mobileMenu/MobileMenu";
import headerLogo from "../../assets/images/header-logo.svg";
import { useNavigate } from "react-router-dom";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";


const Header = () => {

  const [isMobileMenu, setMobileMenu] = useState(false);

  const handleMobileMenu = () => {
    setMobileMenu(!isMobileMenu);
  };

  const navigate = useNavigate();

  const navigateTo = (path) => {
    window.scrollTo(0, 0);
    navigate(path);
  }

  useEffect(() => {
    const header = document.getElementById("navbar");
    const handleScroll = window.addEventListener("scroll", () => {
      if (window.pageYOffset > 50) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    });

    return () => {
      window.removeEventListener("sticky", handleScroll);
    };
  }, []);


  return (
    <NavWrapper className="header_section" id="navbar">
      <div className="container">
        <div className="menu_sect">
          <div className="menu_left_sect">
            <div className="logo">
              <a href="/">
                <img src={headerLogo} alt="logo" />
                <span>CryptoZone</span>
              </a>
            </div>
          </div>
          <div className="menu_right_sect">
            <div className="menu_list">
              <ul>
                <li>
                  <p onClick={() => navigateTo("/")}>Home</p>
                </li>
                <li>
                  <a href="#about">About</a>
                </li>
                <li>
                  <a href="#blog">Blog</a>
                </li>
                <li>
                  <a href="#features">Features</a>
                </li>
                <li>
                  <p onClick={() => navigateTo('/contact')}>Contact Us</p>
                </li>
                <li className="submenu">
                  <a href="# ">Pages <MdOutlineKeyboardArrowDown /></a>
                  <div className="sub_menu_sect">
                    <ul className="sub_menu_list">
                      <li>
                        <p onClick={() => navigateTo('/team')}>Team</p>
                      </li>
                      <li>
                        <p onClick={() => navigateTo('/services')}>Services</p>
                      </li>
                      <li>
                        <p onClick={() => navigateTo('/features')}>Features</p>
                      </li>
                      <li>
                        <p onClick={() => navigateTo('/terms-condition')}>Terms & Condition</p>
                      </li>
                      <li>
                        <p onClick={() => navigateTo('/faq')}> FAQs </p>
                      </li>
                      <li>
                        <p onClick={() => navigateTo('/about')}>About Us </p>
                      </li>
                      <li>
                        <p onClick={() => navigateTo('/blogs')}>Latest Blog</p>
                      </li>
                      <li>
                        <p onClick={() => navigateTo('/post')}>Blog Details</p>
                      </li>
                      <li>
                        <p href="/contact" onClick={() => navigateTo('/contact')}>Contact</p>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
            <div className="menu_btns">
              <button className="menu_btn" onClick={() => handleMobileMenu()}>
                <MdNotes />
              </button>
              <Button sm variant="outline" className="register_btn" onClick={() => navigateTo("/contact")}>
                get register
              </Button>
            </div>
          </div>
        </div>
        {isMobileMenu && <MobileMenu mobileMenuhandle={handleMobileMenu} />}
      </div>
    </NavWrapper>
  );
};

export default Header;
